import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => {
    return {
        bgBox: {
            backgroundImage: "url('/assets/img/loginBg.jpg')",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "4px",
            backgroundSize: "100% 100%",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            height: "100vh",
            width: "100vw",
        },
        mainBox: {
            borderRadius: "30px",
            border: "1px solid #E0E0E0",
            padding: "3.5rem",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            maxWidth: "600px",
            backgroundColor: "#fff",
            [theme.breakpoints.down(900)]: {
                width: "76%",
                padding: "2.5rem",
            },
            [theme.breakpoints.down(600)]: {
                width: "80%",
                padding: "2rem",
            },
            [theme.breakpoints.down(425)]: {
                width: "90%",
                padding: "1rem 1rem 1.5rem 1rem",
            },
        },
        subBtn: {
            color: "#FFFFFF",
            backgroundColor: "#E77843",
            borderRadius: "10px",
            fontSize: "14px",
            fontWeight: 700,
            textTransform: "capitalize",
            // marginTop: "2rem",
            padding: "10px",
            "&:hover": {
                backgroundColor: "#E77843",
            },
            [theme.breakpoints.down(425)]: {
                padding: "5px",
            },
        },
        logoImage: {
            height: "54px",
            width: "54px",
            [theme.breakpoints.down(900)]: {
                height: "50px",
                width: "50px",
            },
            [theme.breakpoints.down(600)]: {
                height: "45px",
                width: "45px",
            },
            [theme.breakpoints.down(425)]: {
                height: "40px",
                width: "40px",
            },
        }
    };
});

const CommonAuth = ({ children, boxShadow, onButtonClick, submitButtonName, children2, btnMarginTop }) => {
    const { classes } = useStyles();

    return (
        <>
            <Box className={classes.bgBox}>
                <Box className={classes.mainBox} sx={{ boxShadow: boxShadow ? boxShadow : "13px -5px 50px 0px rgba(255, 127, 82, 0.10)", }}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: { xs: "0", sm: "0 5rem", md: "0 7rem" },
                        }}
                    >
                        <img src="/assets/img/Logo.svg" alt="Logo" className={classes.logoImage} />
                        <Typography
                            sx={{
                                fontSize: { xs: "22px", sm: "20px", md: "22px" },
                                color: "#131313",
                                ml: "10px",
                                fontFamily: "Satoshi-Bold !important",
                            }}
                        >
                            Spoton Coating
                        </Typography>
                    </Box>
                    {children}
                    <Box sx={{ width: '100%', mt: btnMarginTop ? btnMarginTop : '3rem' }}>
                        <Button className={classes.subBtn} onClick={onButtonClick} fullWidth>
                            {submitButtonName || "Submit"}
                        </Button>
                    </Box>
                    {children2}
                </Box>
            </Box>
        </>
    );
}

export default CommonAuth;
